import React, {Component} from 'react';
import {connect} from 'react-redux';
import {SubmissionError} from 'redux-form';
import {Actions} from '../../../../../common/actions';
import {validIccCategories, validIccSubcategories} from '../../../../../common/util/fieldsValidation';
import IccParametersForm from './form';
import './index.scss';

class EditIccParameters extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  validateWadInRangeCategories(invalidFields, formValues) {
    const categoriesFields = Object.keys(formValues).filter((categoryField) => {
      const isValidCategoryWad = (categoryField.startsWith('a') || categoryField.startsWith('b') ||
      categoryField.startsWith('c') || categoryField.startsWith('d') ||
      categoryField.startsWith('e')) && (categoryField.endsWith('Max') ||
      categoryField.endsWith('Min')) && categoryField.length === 4;
      return isValidCategoryWad;
    });

    categoriesFields.sort().reverse();

    for (let i = 0; i < categoriesFields.length - 1; i++) {
      const isMaxValue = categoriesFields[i].endsWith('Max');
      if (!validIccCategories(formValues[categoriesFields[i]], formValues[categoriesFields[i + 1]],
        isMaxValue)) {
        invalidFields[categoriesFields[i]] = 'Verifique el valor';
      }
    }
    return invalidFields;
  }

  validateMsmInRangeCategories(invalidFields, formValues) {
    const categoriesFields = ['kMax', 'kMin', 'jMax', 'jMin', 'hMax', 'hMin', 'gMax', 'gMin',
      'fMax', 'fMin'];

    for (let i = 0; i < categoriesFields.length - 1; i++) {
      const isMaxValue = categoriesFields[i].endsWith('Max');
      if (!validIccSubcategories(formValues[categoriesFields[i]],
        formValues[categoriesFields[i + 1]], isMaxValue)) {
        invalidFields[categoriesFields[i]] = 'Verifique el valor';
      }
    }
    return invalidFields;
  }

  validateRangeSubcategories(invalidFields, formValues) {
    const subCategoriesFields = ['fiveMax', 'fiveMin', 'fourMax', 'fourMin', 'threeMax', 'threeMin',
      'twoMax', 'twoMin', 'oneMax', 'oneMin'];

    for (let i = 0; i < subCategoriesFields.length - 1; i++) {
      const isMaxValue = subCategoriesFields[i].endsWith('Max');
      if (!validIccSubcategories(formValues[subCategoriesFields[i]],
        formValues[subCategoriesFields[i + 1]], isMaxValue)) {
        invalidFields[subCategoriesFields[i]] = 'Verifique el valor';
      }
    }
    return invalidFields;
  }

  onSubmit(formValues) {
    const floatValues = {};
    Object.keys(formValues).forEach((element) => {
      floatValues[element] = parseFloat(formValues[element]);
    });

    let invalidFields = {};
    invalidFields = this.validateWadInRangeCategories(invalidFields, floatValues);
    invalidFields = this.validateMsmInRangeCategories(invalidFields, floatValues);
    invalidFields = this.validateRangeSubcategories(invalidFields, floatValues);
    if (Object.keys(invalidFields).length !== 0) {
      throw new SubmissionError(invalidFields);
    }
    return this.props.saveIccParameters(floatValues);
  }

  render() {
    return (
      <IccParametersForm
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const {
  saveIccParameters,
  addMessageBoxError,
} = Actions;

export default connect(mapStateToProps, {
  saveIccParameters,
  addMessageBoxError,
  validIccCategories,
  validIccSubcategories,
})(EditIccParameters);
